// tslint:disable:max-line-length
import { createAction, props } from '@ngrx/store';
import { SearchResult } from '../../models';

export const LoadSearchResults = createAction('[Command palette] Load Search Results', props<{ query: string }>());
export const LoadSearchResultsSuccess = createAction('[Command palette] Load Search Results Success', props<{ results: SearchResult[] }>());
export const LoadSearchResultsFail = createAction('[Command palette] Load Search Results Fail', props<{ error: any }>());
